import { useEffect } from 'react';
import useProcesses from '@pkg/api/libraries/processes/queries/useProcesses';
import useAuthStore from '@pkg/auth/useStore';
import useStore from './useStore';

export default function useLive() {
  const {
    isAuthenticated,
    isLoading: isAuthLoading,
    hasLimitedAccess,
  } = useAuthStore();
  const setProcesses = useStore((state) => state.setProcesses);
  const setLoading = useStore((state) => state.setLoading);

  const { data: processes, isLoading: isProcessesLoading } = useProcesses();

  useEffect(() => {
    if (isAuthLoading || isProcessesLoading) {
      return;
    }

    if (!isAuthenticated && !hasLimitedAccess) {
      setProcesses([]);
      setLoading(false);
      return;
    }

    if (!processes) {
      return;
    }

    setProcesses(processes);
    setLoading(false);
  }, [
    processes,
    isAuthenticated,
    hasLimitedAccess,
    isAuthLoading,
    isProcessesLoading,
  ]);
}
